import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@shared/api';

export interface InboxSummary {
  needs_reply: number;
  last_event_at: string | null;
}

export interface InboxItem {
  id: string;
  short: string;
  status: 'waiting' | 'active' | 'closed';
  client: string;
  channel: string;
  platform: 'widget' | 'max' | 'telegram' | 'api' | string;
  avatar: string | null; // фото клиента в мессенджере
  unread: number; // сообщений клиента после последнего ответа оператора
  assistant: string;
  operator: string | null;
  last_text: string;
  last_at: string | null;
  needs_reply: boolean;
}

export interface InboxFile {
  name: string;
  mime: string;
  size: number;
  kind: 'image' | 'file' | 'video' | 'audio' | string;
  url: string; // относительно API
  deleted: boolean; // удалён по сроку хранения (30 дней)
}

export interface InboxMessage {
  id: string;
  sender: 'user' | 'ai' | 'operator' | 'system';
  text: string;
  created_at: string | null;
  files: InboxFile[];
}

export const operatorKeys = {
  summary: ['operators', 'summary'] as const,
  inbox: ['operators', 'inbox'] as const,
  session: (id: string) => ['operators', 'inbox', id] as const,
};

/** Сколько запросов ждут ответа — для красной точки, значка вкладки и щелчка. */
export function useInboxSummary() {
  return useQuery<InboxSummary>({
    queryKey: operatorKeys.summary,
    queryFn: async () => (await httpClient.get<InboxSummary>('/operators/inbox/summary')).data,
    refetchInterval: 5000,
    refetchIntervalInBackground: true, // вкладка свёрнута — значок и щелчок всё равно нужны
    retry: false,
  });
}
